<template>
  <div v-if="offerta">
    <div v-if="nomeSquadra">
      <div class="squadra-offerta">
        <div class="squadra-wrapper">
          <img class="picture" :src="picSquadra" />
          <span class="offerta">{{ offerta }}</span>
        </div>

        <div v-if="label != ''" class="text-left ml-2">
          {{ label }} <br />
          <strong>{{ nomeSquadra }}</strong>
          <div v-if="time" class="offerta_time">
            <v-icon small left>access_time</v-icon
            ><small><span v-html="time"></span></small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="ifNoOfferta != ''">
      <div>{{ ifNoOfferta }}</div>
    </div>
  </div>
</template>

<script>
import mixins from "../../js/mixins";

export default {
  name: "squadra-offerta",
  mixins: [mixins],
  props: {
    offerta: {
      type: Number,
      required: false,
      default: null,
    },
    uid: {
      type: [Number, String],
      required: false,
      default: null,
    },
    time: {
      type: [Number, String],
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: "Migliore offerta",
    },
    ifNoOfferta: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    nomeSquadra() {
      try {
        return this.squadra(this.uid).name;
      } catch (error) {
        return false;
      }
    },
    picSquadra() {
      try {
        return this.squadra(this.uid).pic;
      } catch (error) {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.squadra-offerta {
  display: flex;
  justify-content: center;
  align-items: center;
  .squadra-wrapper {
    display: inline-block;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    position: relative;
    box-shadow: 0 2px 5px rgb(0 0 0 / 8%);
    background: white;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      border: 3px solid white;
      position: absolute;
      top: 0;
      left: 0;
    }
    .offerta {
      position: absolute;
      width: 25px;
      height: 25px;
      top: -3px;
      right: -7px;
      min-width: 25px;
    }
  }
}
</style>
